import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guard/auth.guard';

const othersRoutes: Routes = [
    { path: 'others/contacts', loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsPageModule),
        canActivate: [AuthGuard] },
    { path: 'others/help',     loadChildren: () => import('./help/help.module').then(m => m.HelpPageModule),
        canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(othersRoutes)],
    exports: [RouterModule]
})
export class OthersRoutingModule {
}
